// How a saved card is named on screen. The API reports its brand now (it used
// to leave it out, and the subscription page said "Visa" whatever the card was),
// the last four digits and the expiry.

const BRAND_NAMES = {
   visa: "Visa",
   mastercard: "Mastercard",
   amex: "American Express",
   discover: "Discover",
   diners: "Diners Club",
   jcb: "JCB",
   unionpay: "UnionPay",
   cartes_bancaires: "Cartes Bancaires"
};

/** A card brand as people write it, or "Card" when there is none to name. */
export const formatCardBrand = (brand) => {
   if (!brand || String(brand).toLowerCase() === "unknown") return "Card";

   const key = String(brand).toLowerCase();
   return BRAND_NAMES[key] ?? key.charAt(0).toUpperCase() + key.slice(1);
};

/** "04/27", or null without both parts. */
export const formatCardExpiry = (expMonth, expYear) =>
   expMonth && expYear
      ? `${String(expMonth).padStart(2, "0")}/${String(expYear).slice(-2)}`
      : null;

/** "Visa ending in 4242, expires 04/27" — or null when there is no card to describe. */
export const describeCard = (card) => {
   if (!card?.last4) return null;

   const expiry = formatCardExpiry(card.expMonth, card.expYear);
   return `${formatCardBrand(card.brand)} ending in ${card.last4}${expiry ? `, expires ${expiry}` : ""}`;
};
